import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ae05134")

_pushScopeId("data-v-8ae05134")
const _hoisted_1 = { class: "analysis pt32" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "publishStates" }
const _hoisted_5 = { class: "jobStatus" }
const _hoisted_6 = { class: "score" }
const _hoisted_7 = { class: "score" }
const _hoisted_8 = { class: "action flex align-items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_pagination = _resolveComponent("a-pagination")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_a_table, {
          "row-key": "id",
          pagination: false,
          loading: _ctx.tableLoading,
          "data-source": _ctx.tableList,
          columns: _ctx.columns
        }, {
          assignmentModel: _withId(({record}) => [
            _createVNode("div", _hoisted_4, _toDisplayString(record.assignmentModel === 1  ? '考核模式' : '练习模式'), 1)
          ]),
          jobStatus: _withId(({record}) => [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getJobStatus(record)), 1)
          ]),
          score: _withId(({record}) => [
            _createVNode("div", _hoisted_6, _toDisplayString(record.score ?? '-'), 1)
          ]),
          ranking: _withId(({record}) => [
            _createVNode("div", _hoisted_7, _toDisplayString([undefined, -1].includes(record.ranking) ? '-' : record.ranking), 1)
          ]),
          action: _withId(({record}) => [
            _createVNode("div", _hoisted_8, [
              (record.publishStates)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: ["text-btn pointer mr8", {'disabled-txt': !_ctx.isRanking(record)}],
                    onClick: ($event: any) => (_ctx.isRanking(record) && _ctx.gotoInfo(record))
                  }, "查看", 10, ["onClick"]))
                : (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: ["text-btn pointer mr8", {'disabled-txt': _ctx.isStartDisabled(record)}],
                    onClick: ($event: any) => (!_ctx.isStartDisabled(record) && _ctx.gotoStart(record))
                  }, "答题", 10, ["onClick"]))
            ])
          ]),
          _: 1
        }, 8, ["loading", "data-source", "columns"])
      ]),
      _createVNode(_component_a_pagination, {
        class: "page",
        current: _ctx.pageNo,
        "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageNo = $event)),
        pageSize: _ctx.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pageSize = $event)),
        total: _ctx.total,
        showSizeChanger: "",
        "show-quick-jumper": "",
        onChange: _ctx.pageChange,
        onShowSizeChange: _ctx.showSizeChange
      }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])
    ])
  ]))
})